import {Formik} from "formik";
import {Button, Modal} from "react-bootstrap";
import {useDispatch} from "react-redux";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import {updateProfileAction} from "../../../store/actions/AuthActions";
import OTP from "../../../images/OTP.svg";
import {verifyCodeOTP, verifyTelephone} from "../../../services/AuthService";
import {useEffect, useState} from "react";
import SixDigitInput from "../shared/CodeInputTel";
import TurnstileWidget from "../shared/TurnstileWidget";
const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", // Enables flexbox
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically
  },
  content: {
    position: "relative",

    width: "100%",
    maxWidth: "554px", // Controls modal width
    maxHeight: "90vh", // Ensures it doesn't exceed the viewport height
    margin: "auto", // Centers in case of fallback
    borderRadius: "12px",
    padding: "24px",
    overflow: "auto", // Enables scroll for overflowing content
  },
};

export const VerifTelModal = ({show, setShow, email, phone, handleSubmit}) => {
  const normalizedPhone = String(phone || "").replace(/[\s.-]/g, "");
  const [errors, setErrors] = useState({code: false, verif: false});
  const [verifCode, setVerifCode] = useState(new Array(6).fill(""));
  const [codeSent, setCodeSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileRequired, setTurnstileRequired] = useState(true);
  const [turnstileResetKey, setTurnstileResetKey] = useState(0);

  const SendCode = async () => {
    if (turnstileRequired && !turnstileToken) {
      setErrors((prev) => ({
        ...prev,
        code: "Veuillez valider la protection anti-robot.",
      }));
      return;
    }
    setSending(true);
    setErrors((prev) => ({...prev, code: false}));
    try {
      await verifyTelephone({
        phone: normalizedPhone,
        turnstileToken: turnstileToken || "",
      });
      setCodeSent(true);
      setVerifCode(new Array(6).fill(""));
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        code:
          error?.response?.data?.error ||
          "Erreur lors de l'envoi du code de vérification.",
      }));
    } finally {
      setTurnstileToken(null);
      setTurnstileResetKey((current) => current + 1);
      setSending(false);
    }
  };

  useEffect(() => {
    if (!!show) {
      setErrors({code: false, verif: false});
      setVerifCode(new Array(6).fill(""));
      setCodeSent(false);
      setTurnstileToken(null);
      setTurnstileResetKey((current) => current + 1);
    }
  }, [show, phone]);
  const verifyCode = () => {
    const newCode = verifCode.join("");
    if (newCode.length < 6) {
      setErrors((prev) => ({...prev, verif: "champ obligatoire"}));
      return;
    }
    verifyCodeOTP({
      phone: normalizedPhone,
      code: newCode,
    })
      .then((response) => {
        handleSubmit();
      })
      .catch((err) => {
        setErrors((prev) => ({...prev, verif: "problème de verification"}));
      });
  };

  return (
    <Modal
      className="modal fade"
      show={show}
      onHide={() => {
        setShow(false);
      }}
      style={modalStyles}
      centered
    >
      <div className="modal-content">
        <div className="modal-header !border-none">
          <Button
            variant=""
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              setShow(false);
            }}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !p-2">
          <div className=" flex flex-col gap-2 justify-center items-center !px-12 ">
            <img src={OTP} alt="otp" className="w-28 !mb-4" />
            <div className="text-[#2EBD04] font-bold text-xl text-center !px-3">
              Vérification du nouveau numéro de téléphone
            </div>

            {errors.code ? (
              <div className="text-[#FF0000] text-center font-normal text-sm !px-3">
                {errors.code}
              </div>
            ) : codeSent ? (
              <div className="text-[#19295C] text-center font-semibold text-lg !px-3">
                Un code de vérification a été envoyé sur votre téléphone
              </div>
            ) : null}
            <TurnstileWidget
              onTokenChange={setTurnstileToken}
              onRequirementChange={setTurnstileRequired}
              resetKey={turnstileResetKey}
            />
            {codeSent ? (
              <>
                <div className="form-group ">
                  <SixDigitInput
                    small={true}
                    values={verifCode}
                    setValues={setVerifCode}
                  />
                  {!!errors.verif && (
                    <div className="text-danger fs-12">{errors.verif}</div>
                  )}
                  <div className="flex justify-end items-center mt-1 font-medium text-[#7E7E7E] leading-4 text-sm">
                    <button
                      type="button"
                      className="underline disabled:cursor-not-allowed disabled:opacity-60"
                      disabled={sending}
                      onClick={SendCode}
                    >
                      {sending ? "Envoi en cours…" : "Renvoyer le code ?"}
                    </button>
                  </div>
                </div>
                <button
                  onClick={verifyCode}
                  type="button"
                  className="!rounded-md w-full mb-2 !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm"
                >
                  Vérifier mon numéro
                </button>
              </>
            ) : (
              <button
                onClick={SendCode}
                disabled={sending}
                type="button"
                className="!rounded-md w-full mb-2 !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm disabled:opacity-60"
              >
                {sending ? "Envoi en cours…" : "Envoyer le code de vérification"}
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
